export default __webpack_public_path__ + "static/media/ic-online-lessons.7408ec1d.svg";